// File Preview

import  React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import Popup from 'reactjs-popup';
import {BigPlayButton, ControlBar, ForwardControl, Player, ReplayControl, VolumeMenuButton} from 'video-react';

// Icon & Framework
import * as Icon from 'ubs-icons';
import {useEscKey} from "ubs-framework/v2/hooks";
import {COLOR, FILE, LIMIT} from "ubs-framework/v2/common/constant";

import { getThumbor } from "ubs-framework/v2/common/function";

const FilePreview = () => {
    const DISPATCH = useDispatch();

    const _FILES = useSelector(e => e.common?.files?.files);
    const _ACTIVE = useSelector(e => e.common?.files?.active);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const [active, setActive] = useState(-1);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => setActive(_ACTIVE || 0), [_FILES]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyboardEvent, true);
        return () => document.removeEventListener('keydown', handleKeyboardEvent);
    }, []);

    const slidesNav = (n) => setActive(prevState => {
        let i = prevState += n
        if (i === -1) i = _FILES.length - 1
        else if (i === _FILES.length) i = 0
        return i || 0
    })

    const closePopupOutsideClick = (e) => {
        if (e.target.className === 'u_file-view-body' || e.target.className === 'u_file-view-inner') close()
    }

    useEscKey(() => close());

    const close = () => DISPATCH({type: 'SET_FILES', payload: {}})

    const handleCorruptedImage = (e) => e.target.src = '/images/files/other.svg';

    const handleKeyboardEvent = (e) => {
        if (_FILES.length > 1) {
            if (e.keyCode === 37) slidesNav(-1)
            else if (e.keyCode === 39) slidesNav(1)
        }
    }

    const downloadFiles = (file) => {
        let iframe = document.createElement("iframe");
        iframe.style.visibility = "collapse";
        document.body.append(iframe);
        const url = _S3_BASE_URL + file.url;
        iframe.contentDocument.write(
            `<form action="${url.replace(/\"/g, '"')}" method="GET"/>`
        );
        iframe.contentDocument.forms[0].submit();

        setTimeout(() => iframe.remove(), 2000);
    };

    return (
        <React.Fragment>
            {active !== -1 && (
                <div className="u_file-view" onClick={closePopupOutsideClick}>
                    <div className="u_file-view-inner">
                        <div className="u_file-view-header u_flex u_align-center">
                            <p className="u_file-title u_one-line">{_FILES[active]?.fileName}</p>
                            <div className="u_file-action u_flex u_align-center">
                                <Popup
                                    trigger={open => (
                                        /*<a href={`${_S3_BASE_URL}${_FILES[active].url}`} target="_blank" download
                                           className="u_block u_cp u_lh-0">
                                            <DownloadIcon fill={COLOR.u_white} width="24px" height="24px"/>
                                        </a>*/
                                        <span className="u_icon-rollover" onClick={() => downloadFiles(_FILES[active])}> <Icon.Download
                                            fill={COLOR.u_white} size={24}/> </span>
                                    )}
                                    arrow={true}
                                    on={['hover', 'focus']}
                                    position="bottom center"
                                    closeOnDocumentClick
                                    offsetY={5}
                                    repositionOnResize
                                    keepTooltipInside={true}
                                    className="u_tooltip"
                                    mouseEnterDelay={LIMIT.TOOLTIP_DELAY}
                                >
                                    <span>Download</span>
                                </Popup>

                                <Popup arrow={true} on={['hover', 'focus']} position="bottom center"
                                       closeOnDocumentClick offsetY={5}
                                       repositionOnResize
                                       keepTooltipInside={true} className="u_tooltip"
                                       mouseEnterDelay={LIMIT.TOOLTIP_DELAY}
                                       trigger={open => (
                                           <span className="u_ml-10 u_cp u_close-icon" onClick={close}><Icon.Close
                                               fill={COLOR.u_white} size={14}/></span>
                                       )}>
                                    <span>Close [Esc]</span>
                                </Popup>
                            </div>
                        </div>

                        <div className="u_file-view-body">
                            {
                                _FILES[active] &&
                                <React.Fragment>

                                    {/* Image */}
                                    {
                                        FILE.IMAGES.test(_FILES[active].url) &&
                                        <>
                                            {isLoading && <Icon.Preloader/>}
                                            <div className={isLoading ? 'u_hidden' : 'u_file-popup u_file-popup-image'}>
                                                <img className="u_file" src={_S3_BASE_URL + _FILES[active].url} alt=""
                                                     onLoad={() => setIsLoading(false)}/>
                                            </div>
                                        </>
                                    }

                                    {/* Video */}
                                    {
                                        FILE.VIDEO.test(_FILES[active].url) &&
                                        <div className="u_file-popup u_file-popup-video u_video-bg u_relative">
                                            <Player
                                                fluid={false}
                                                width='100%'
                                                playsInline
                                                preload="auto"
                                                src={_S3_BASE_URL + _FILES[active].url}
                                                // aspectRatio="16:9"
                                            >
                                                <ControlBar>
                                                    <ReplayControl seconds={10} order={1.1}/>
                                                    <ForwardControl seconds={10} order={1.2}/>
                                                    <VolumeMenuButton vertical/>
                                                </ControlBar>
                                                <BigPlayButton position="center"/>
                                            </Player>
                                        </div>
                                    }

                                    {/** Other files */}
                                    {
                                        !FILE.IMAGES.test(_FILES[active].url) && !FILE.VIDEO.test(_FILES[active].url) &&
                                        <div className="u_file-popup u_file-popup-other">
                                            <div className="u_file">
                                                <div className="u_file-icon">
                                                    <img src={`/images/files/${_FILES[active].ext}.svg`}
                                                         align={_FILES[active].ext} onError={handleCorruptedImage}
                                                         className="u_file-icon-image" alt={''}/>
                                                </div>
                                                <p className="u_file-name">{_FILES[active].fileName}</p>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            }
                        </div>

                        <div className="u_thumbnails-file">
                            <div className="u_thumbnails-file-inner">
                                {
                                    _FILES.map((file, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                                {/* Image */}
                                                {
                                                    file && FILE.IMAGES.test(file.url) &&
                                                    <div
                                                        className={`u_file-popup u_file-popup-image ${_FILES[active]?._id === file?._id && 'u_active'}`}>
                                                        <img className="u_file"
                                                             src={getThumbor() + _S3_BASE_URL + file.url} alt=""/>
                                                    </div>
                                                }

                                                {/* Video */}
                                                {
                                                    file && FILE.VIDEO.test(file.url) &&
                                                    <div
                                                        className={`u_file-popup u_file-popup-video ${_FILES[active]._id === file._id && 'u_active'}`}>
                                                        <video className="u_file" src={_S3_BASE_URL + file.url}/>
                                                    </div>
                                                }

                                                {/** Other files */}
                                                {
                                                    file && !FILE.IMAGES.test(file.url) && !FILE.VIDEO.test(file.url) &&
                                                    <div
                                                        className={`u_file-popup u_file-popup-other ${_FILES[active]._id === file._id && 'u_active'}`}>
                                                        <div className="u_file">
                                                            <div className="u_file-icon">
                                                                <img src={`/images/files/${file.ext}.svg`}
                                                                     align={file.ext} onError={handleCorruptedImage}
                                                                     className="u_file-icon-image" alt={''}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>

                    {_FILES.length > 1 && (
                        <React.Fragment>
                            <a className="u_prev-icon" onClick={() => slidesNav(-1)}><Icon.LeftArrow
                                fill={COLOR.u_white} size={50}/></a>
                            <a className="u_next-icon" onClick={() => slidesNav(1)}><Icon.RightArrow
                                fill={COLOR.u_white} size={50}/></a>
                        </React.Fragment>
                    )}

                </div>
            )}
        </React.Fragment>
    );
};

export default FilePreview;
